export const getters = {
  classroom: (state) => {
    return state.classroom
  }
}
